// removed by extract-text-webpack-plugin
module.exports = {"SignUp":"SignUp__SignUp__3efdN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Security/SignUp/SignUp.css
// module id = 152
// module chunks = 0